;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = undefined;globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = "";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs';

import { isDevelopment, isProduction } from 'src/lib/constants';
import { hasPerformanceConsentCookie } from 'src/lib/onetrust-consent-cookie';

// OneTrust loads after this runs, so consent comes from its cookie. Consent
// changes reload the page (see ConsentManager), which re-runs this.
const hasPerformanceConsent = hasPerformanceConsentCookie();

// Registered by @sentry/nextjs webpack (must be instrumentation-client.{ts,js}
// under src/, or sentry.client.config at repo root.) See sentry-nextjs-sdk SKILL.
Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: isProduction,
  sendDefaultPii: hasPerformanceConsent,
  tracesSampleRate: isDevelopment ? 1.0 : 0.01,
  enableLogs: true,
  // @sentry/nextjs adds BrowserTracing by default.
  integrations: (defaults) => {
    return hasPerformanceConsent
      ? defaults
      : defaults.filter((integration) => {
          return integration.name !== 'BrowserTracing';
        });
  },
});
